import type { RevenueBasis } from '@/api/revenue'
import type { FormatOptions } from '@/design'
import type { GlobalFilters } from '@/lib/filters'

import { LeakageTab } from './leakage/LeakageTab'
import { LifecyclePanel } from './lifecycle/LifecyclePanel'
import { OrdersTab } from './orders/OrdersTab'

/*
 * The places the lifecycle and leakage card (ci-w18-revenue-leakage) fills: the Leakage
 * and Orders tabs and the Timing tab's lifecycle panel, each its own component
 * (`leakage/LeakageTab`, `orders/OrdersTab`, `lifecycle/LifecyclePanel`) taking these
 * props: the page's filters, its basis and how money reads.
 */

export interface RevenueSlotProps {
  filters: GlobalFilters
  basis: RevenueBasis
  money: FormatOptions
}

export function LeakageTabSlot(props: RevenueSlotProps) {
  return <LeakageTab {...props} />
}

export function OrdersTabSlot(props: RevenueSlotProps) {
  return <OrdersTab {...props} />
}

export function LifecyclePanelSlot(props: RevenueSlotProps) {
  return <LifecyclePanel {...props} />
}
